var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        class: {
          "container-fluid": true,
          "location-detail": _vm.selectedLocation != null
        }
      },
      [
        !_vm.location && _vm.selectedLocation == null
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-6 location-search-container" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12", attrs: { id: "main-content" } },
                      [
                        _c(
                          "h1",
                          {
                            staticClass: "h3 location-search-container__title"
                          },
                          [_vm._v(_vm._s(_vm.pageTitle))]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("filter-view"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "location-search-container__results desktop"
                    },
                    [_c("app-results-list")],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-6 fixed-right map-container",
                  attrs: { role: "region", "aria-label": "map" }
                },
                [_c("map-view")],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.location || _vm.selectedLocation != null
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-lg-6 location-search-container single" },
                [
                  _c("results-detail-item", {
                    attrs: {
                      location: _vm.selectedLocation,
                      unSelectLocationClick: _vm.unSelectLocationFn
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-6 fixed-right map-container single",
                  attrs: { role: "region", "aria-label": "map" }
                },
                [
                  _vm.selectedLocation != null && _vm.selectedLocation.teaser
                    ? _c("teaser-block")
                    : _vm._e(),
                  _vm._v(" "),
                  _c("map-view")
                ],
                1
              )
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.isMobile ? _c("div", [_c("app-results-list")], 1) : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }